<div class="row">
  <div class="col-12 col-md-12">
    <section>
      <div class="row">
        <form class="needs-validation container-style" [formGroup]="formContact">
          <div class="ps-2 pe-2 pb-2">
            <div class="row">
              <div class="col-lg-3 col-md-5 col-sm-6 col-12">
                <app-custom-input-text formControlName="name" [labelText]="'Nombre'"
                  [required]="true"></app-custom-input-text>
              </div>
              <div class="col-lg-2 col-md-5 col-sm-6 col-12">
                <app-custom-input-text formControlName="position" [labelText]="'Cargo'"
                  [maxLength]="100"></app-custom-input-text>
              </div>
              <div class="col-lg-1 col-md-2 col-sm-6 col-6">
                <app-custom-input-text formControlName="phone" [labelText]="'Teléfono 1'" [maxLength]="100"
                  [required]="true"></app-custom-input-text>
              </div>
              <div class="col-lg-1 col-md-2 col-sm-6 col-6">
                <app-custom-input-text formControlName="phone2" [labelText]="'Teléfono 2'"
                  [maxLength]="100"></app-custom-input-text>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-10 col-12">
                <app-custom-input-text formControlName="email" [labelText]="'E-mail'"
                  [maxLength]="250"></app-custom-input-text>
              </div>
              <div class="col-lg-1 col-md-2 col-sm-2 col-6 d-flex align-items-end mt-2 justify-content-start">
                <app-custom-button *ngIf="formContact.dirty" [title]="'Limpiar'" [icon]="'pi pi-eraser'"
                  [severity]="'contrast'" (onClick)="newContact()"></app-custom-button>
              </div>
              <div class="col-lg-1 col-md-2 col-sm-2 col-6 d-flex align-items-end mt-2 justify-content-end">
                <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [variant]="undefined"
                  (onClick)="send()"></app-custom-button>
              </div>
            </div>
          </div>
        </form>
        <section class="row mt-2">
          <div class="container-style mx-0">
            <div class="col-lg-12">
              <app-custom-table [headers]="header" [data]="detailData" [actions]="tableActions" [showExport]="true"
                [showRecover]="true" (onPageChange)="onPageChange($event)"
                (onRecoverData)="getAllContactsWithPagination()" (onAction)="onAction($event)" (onExport)="onExport()">
              </app-custom-table>
            </div>
          </div>
        </section>
      </div>
    </section>
  </div>
</div>